<script>
import ConfirmationQuestion from '@components/confirmation-question'
import rappiUtils from '@/mixins/rappi-utils.js'
import deepLink from '@/mixins/deeplink.js'
import { widgetActions } from '@state/helpers'
import { mapGetters } from 'vuex'
import attachment from '@/mixins/attachment-utils.js'
import ENV from '@src/env'
import axios from 'axios'

export default {
  name: 'CallRT',
  components: {
    ConfirmationQuestion,
  },
  mixins: [rappiUtils(), deepLink(), attachment()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      alreadyCallRT: false,
      rtImg: null,
    }
  },

  computed: {
    ...mapGetters('widgets', ['userEnv']),
    namedRtImgUri () {
      return `${ENV.rappi.storekeeper.image[this.userEnv]}/${
        this.componentData.storekeeperImage
        }`
    },
    token () {
      return this.$route.query.token || {}
    },
    orderId () {
      return this.$route.query.order_id
    },
  },
  watch: {
    alreadyCallRT () {
      this.commitWidgetChanges({
        widgetName: 'ConfirmationQuestion',
        data: {
          show: this.alreadyCallRT,
        },
      })
    },
  },
  created () {
    this.getRtImg()
  },
  methods: {
    ...widgetActions,
    imageFallBack () {
      this.rtImg = this.defaultRtImg()
    },
    imageExists (imageUrl) {
      var http = new XMLHttpRequest()
      http.open('HEAD', imageUrl, false)
      http.send()
      return http.status !== 404
    },
    goodImg (img) {
      this.rtImg = img
    },
    badImg () {
      this.rtImg = this.rtImg ? this.rtImg : null
    },
    getRtImg () {
      const { storekeeperImage } = this.componentData
      if (!storekeeperImage) return (this.rtImg = this.defaultRtImg())
      this.rtImg = this.validUrl(storekeeperImage)
        ? storekeeperImage
        : this.namedRtImgUri
    },
    defaultRtImg () {
      let image = require.context('@assets/images/', false, /\.png$/)
      return image('./rtIcon.png')
    },
    async callRT () {
      this.alreadyCallRT = true
      let responseProxy
      if (this.orderId) {
        const createProxySession = {
          sender_type: 'application_user',
          receiver_type: 'storekeeper',
          order_id: this.orderId
        }
        responseProxy = await this.createProxySession(createProxySession)
      }

      this.$ga.event({
        eventCategory: 'Non-Live',
        eventAction: 'actionCallRT',
        eventLabel: 'callRT',
        eventValue: 1,
      })

      const { phone_to_call: phoneNumber = this.componentData.storekeeperTelephone } =
        responseProxy.data || {}

      this.callPhone(phoneNumber);
    },
    validUrl (url) {
      // var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
      // var regex = new RegExp(expression)
      // return url.match(regex)
      return url ? url.includes('http') : false
    },
    onCopySuccess () {
      this.alreadyCallRT = true
      this.$toasted.show(`${this.$t('COMMON.COPY_TO_CLIPBOARD')}`)

      this.$ga.event({
        eventCategory: 'Non-Live',
        eventAction: 'CopyRTNumber',
        eventLabel: 'CopyRTNumber',
        eventValue: 123,
      })
    },
    onCopyError () {
      this.$toasted.show('Could not be copied the number', {
        className: this.$style.toast,
      })

      this.$ga.event({
        eventCategory: 'Non-Live',
        eventAction: 'CopyRTNumber',
        eventLabel: 'NotCopyRTNumber',
        eventValue: 123,
      })
    },
    createProxySession (body) {
      return axios.post(
        `${ENV.rappi.url[this.userEnv]}/api/communication-proxy/order-proxy-session/create`,
        body,
        {
          headers: { Authorization: `Bearer ${this.token}` }
        }
      )
    },
  },
}
</script>

<template>
  <div
    v-if="componentData.show"
    :class="$style.container"
  >
    <div :class="$style.container__infoRT">
      <img
        :class="$style.container__profileImage"
        :src="rtImg"
        @error="imageFallBack()"
      >
      <h5 align="left">{{ componentData.storekeeperName }}</h5>
      <p align="left">{{ $t('WIDGETS.CALL_RT.YOUR_RAPPI') }}</p>
      <!-- <p><span>Distancia: 3.5 km</span></p> -->
    </div>

    <div :class="$style.container__actions">
      <!-- <h5> {{ `${$t('COMMON.PHONE')}` }}</h5> -->
      <BaseButton @click="callRT">
        <!-- v-clipboard:copy="infoRT.phone"
        v-clipboard:success="onCopySuccess"
        v-clipboard:error="onCopyError"-->
        <img
          :class="$style.container__actionsImg"
          src="@assets/images/phone@3x.png"
          @error="imageFallBack()"
        >
        <!-- {{ `${infoRT.phone}` }} -->
      </BaseButton>
    </div>
  </div>
</template>
<style scoped lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  margin: $size-spacing-medium 1rem;
  background-color: $white;
  border-radius: 12px;
  box-shadow: $bottom-box-shadow;

  &__profileImage {
    width: 4rem;
    max-width: 6rem;
    height: 4rem;
    max-height: 6rem;
    padding: 1px;
    margin: 0;
    border: 2px solid $white;
    border-radius: 50%;
    box-shadow: $regular-box-shadow;

    @include responsive(phone) {
      width: 5rem;
      height: 5rem;
    }
  }

  &__infoRT {
    display: flex;
    flex-flow: column wrap;
    align-items: left;
    justify-content: center;
    width: 12rem;
    padding-left: 10px;

    @include responsive(phoneS) {
      width: 15rem;
    }

    @include responsive(phone) {
      width: 20rem;
    }

    @include responsive(tablet) {
      width: 25rem;
    }

    h5 {
      @extend %typography-medium;

      width: 100%;
      margin-top: 10px;
      margin-bottom: 0.3rem;
      font-weight: 500;
      line-height: 20px;
      color: $options-color;
    }

    p {
      @extend %typography-medium;

      width: 100%;
      margin: 0;
      color: $disabled;

      span {
        @extend %typography-small;

        color: $medium-gray;
      }
    }
  }

  &__actions {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-around;
    width: 5rem;

    @include responsive(phoneS) {
      width: 6rem;
    }

    button {
      position: relative;
      width: 2.8rem;
      height: 2.8rem;
      margin-top: 20px;
      background: $options-color;
      border-radius: 50%;
    }

    &Img {
      position: absolute;
      top: 10%;
      left: 10%;
      box-sizing: content-box;
      width: 2rem;
      height: 2rem;
      padding: 0.2rem;
      border: unset;
      border-radius: 50%;
    }
  }
}
.toast {
  background-color: $primary-green;
}
</style>
